import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { startCase } from 'lodash'
import moment from 'moment'
import useLiveWinsSocketNameSpace from 'socket-resources/hooks/useLiveWinsSocketNameSpace'
import { LIVE_DATA, LIVE_WINS_RECORDS_LIMIT, LIVE_WINS_TYPES, TRANSACTION_TABS } from 'constants/index'
import { setLiveData } from 'redux-thunk/redux/slices/casino.slice'
import { setItem } from 'helpers/localstorage.helpers'

const AllBets = ({ tab }) => {
  const dispatch = useDispatch()
  const { liveData } = useSelector(state => state.casino)
  const { currencies } = useSelector(state => state.user)
  const [liveTableData, setLiveTableData] = useState(null)
  const { listenLiveWinsUpdateEvent } = useLiveWinsSocketNameSpace()

  const mainCurrencySymbol = currencies?.find(c => c?.primary)?.symbol || '$'

  const handleLiveWinsData = e => { dispatch(setLiveData({ data: e?.data })) }

  useEffect(() => {
    if (liveData?.length > 0) setItem(LIVE_DATA, liveData)
  }, [liveData])

  useEffect(() => {
    const cleanup = listenLiveWinsUpdateEvent(handleLiveWinsData)
    return () => { cleanup() }
  }, [])

  useEffect(() => {
    if (liveData?.length > 1) {
      const agg = liveData.reduce((acc, cur) => {
        const { roundId, type, amount, casinoGameId, gameName, image, user, time } = cur.data
        if (!acc[roundId]) {
          acc[roundId] = { gameName, image, user, time, bet: 0, win: 0 }
        }
        if (type === 'casino-bet') acc[roundId].bet += amount
        else acc[roundId].win += amount
        return acc
      }, {})
      setLiveTableData(agg)
    }
  }, [liveData])

  const rows = liveTableData
    ? Object.values(liveTableData)
        .filter(r => r.bet > 0)
        .slice(0, LIVE_WINS_RECORDS_LIMIT)
    : []

  return (
    <div className={`tab-pane fade show ${tab === TRANSACTION_TABS.ALL_BETS ? 'active' : ''}`} role='tabpanel'>
      <div className='stake-bets-table'>
        <table>
          <thead>
            <tr>
              <th>Game</th>
              <th>User</th>
              <th>Time</th>
              <th>Bet Amount</th>
              <th>Multiplier</th>
              <th>Payout</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={6} className='stake-bets-empty'>Waiting for bets...</td>
              </tr>
            ) : rows.map((row, i) => {
              const multiplier = row.bet > 0 && row.win > 0 ? (row.win / row.bet) : 0
              const profit = row.win - row.bet
              const isWin = profit > 0
              return (
                <tr key={i} className='stake-bets-row'>
                  <td>
                    <div className='stake-bets-game'>
                      {row.image
                        ? <img src={row.image} alt='' className='stake-bets-game-img' />
                        : <div className='stake-bets-game-placeholder' />}
                      <span>{startCase(row.gameName) || '—'}</span>
                    </div>
                  </td>
                  <td className='stake-bets-user'>
                    <i className='fa-solid fa-user-secret stake-bets-anon' />
                    {startCase(row.user?.userName) || 'Hidden'}
                  </td>
                  <td className='stake-bets-time'>{moment(row.time).format('h:mm A')}</td>
                  <td className='stake-bets-amount'>
                    {mainCurrencySymbol} {row.bet.toFixed(4)}
                  </td>
                  <td className={`stake-bets-multiplier ${isWin ? 'win' : 'loss'}`}>
                    {multiplier.toFixed(2)}x
                  </td>
                  <td className={`stake-bets-payout ${isWin ? 'win' : 'loss'}`}>
                    {isWin ? '+' : ''}{mainCurrencySymbol} {profit.toFixed(4)}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default React.memo(AllBets)
